import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00B388",
      fillRule: "evenodd",
      d: "m19.659 3.23-7.088 7.087V3.786a.786.786 0 0 0-1.571 0v8.428a.78.78 0 0 0 .229.554l.003.003a.784.784 0 0 0 .551.229h8.431a.786.786 0 0 0 0-1.571h-6.531L20.77 4.34a.786.786 0 0 0-1.111-1.11Zm-5.014 15.475c1.164-.128 1.76-.82 2.055-1.605.183-.488-.012-.88-.4-1.05-.388-.17-.83.034-1 .5-.206.567-.533.664-1.3.71-.562.034-1.5.14-1.5.14v3.1l-3.05-3c-1.5 0-2.75-.048-4.45-.219-1.205-.12-1.4-.5-1.45-1.781l-.002-.06A46.304 46.304 0 0 1 3.5 13.5c0-.706.024-1.5.1-2 .157-1.036.486-1.514 1.707-1.719.817-.137 1.388-.181 1.943-.181.41 0 .75-.34.75-.75s-.34-.75-.75-.75l-.107-.001c-.263-.005-.716-.014-1.836.152-2.295.34-3.04 1.502-3.18 3.202A36.154 36.154 0 0 0 2 14c0 .5.047 1.61.143 2.483a2.502 2.502 0 0 0 2.217 2.216c2.64.3 4.14.3 4.476.299l2.613 2.571A1.498 1.498 0 0 0 14 20.498V18.77c.22-.02.436-.043.645-.066Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSmsInboundOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SmsInboundOutlined_default = SvgSmsInboundOutlined;

export { SmsInboundOutlined_default as default };
